/* eslint-disable no-const-assign */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-useless-return */
import { useState } from 'react';
// project-imports
import { dispatch, useSelector } from 'store';
import PropTypes from 'prop-types';

// material-ui
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { getCityAutosuggestData } from 'store/slices/memberDetails';
import CircularProgress from '@mui/material/CircularProgress';
import { devConsolelog } from 'helpers/utilityFunctions';

const AutoCompleteCitySearch = ({ formik }) => {
    const memberListData = useSelector((state) => state?.memberDetails);
    const { autosuggestCityData = [] } = memberListData || {};

    const [showDropdownData, setShowDropdownData] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleFilterData = (e, val) => {
        const { name = '', id = '' } = val || {};
        if (name) {
            formik.setFieldValue('city', { id, name });
            // dispatch(filtersData({ ...appliedFilters, search: { search: { id: code } } }));
        } else if (!name) {
            // const tempFilters = { ...appliedFilters };
            // tempFilters.search = {};
            setShowDropdownData(false);
            formik.setFieldValue('city', {});
            // dispatch(filtersData(tempFilters));
        }
    };

    const handleSearch = async (searchedValue = null) => {
        devConsolelog('searched keyword', searchedValue, searchedValue.length);

        if (searchedValue.length > 2) {
            setShowDropdownData(false);
            setLoading(true);
            await dispatch(getCityAutosuggestData(searchedValue));
            setShowDropdownData(true);
            setLoading(false);
        } else {
            setShowDropdownData(false);
            setLoading(false);
        }
    };

    const onBlur = () => {
        setShowDropdownData(false);
    };

    return (
        <Autocomplete
            id="city-search"
            options={!loading && showDropdownData ? autosuggestCityData : []}
            loading={loading}
            onBlur={onBlur}
            value={formik.values.city?.name || null}
            filterOptions={(options) => options}
            onChange={(event, newValue) => {
                handleFilterData(event, newValue);
            }}
            label={
                <Grid
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}
                >
                    <SearchIcon fontSize="small" />
                    <span>&nbsp;City</span>
                </Grid>
            }
            margin="normal"
            renderInput={(params) => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                    label="City"
                    onChange={(e) => {
                        devConsolelog('searched_value', e.target.value);
                        handleSearch(e.target.value);
                    }}
                />
            )}
        />
    );
};

AutoCompleteCitySearch.propTypes = {
    handleSearchByCity: PropTypes.func,
    search: PropTypes.string,
    formik: PropTypes.object
};

export default AutoCompleteCitySearch;
